module.exports = __webpack_public_path__ + "7f8a5b2276402fa755bb76be809fccc8.jpg";